import { Directive, Injector, Input, ViewContainerRef, inject, type DestroyableInjector, type OnChanges, type OnDestroy, type Type } from '@angular/core';
import { BLOCK_RUNTIME, type BlockRuntimeLease } from './block-runtime';

/** Keep the runtime injector alive until the rendered component and its children are gone. */
@Directive({ selector: '[workspaceBlockOutlet]', standalone: true })
export class WorkspaceBlockOutletDirective implements OnChanges, OnDestroy {
  @Input() workspaceBlockOutlet?: Type<unknown>;
  @Input() blockRuntime?: BlockRuntimeLease;
  private readonly view = inject(ViewContainerRef);
  private readonly parent = inject(Injector);
  private injector?: DestroyableInjector;

  ngOnChanges(): void {
    this.clear();
    if (!this.workspaceBlockOutlet || !this.blockRuntime) return;
    this.injector = Injector.create({ parent: this.parent,
      providers: [{ provide: BLOCK_RUNTIME, useValue: this.blockRuntime }] });
    this.view.createComponent(this.workspaceBlockOutlet, { injector: this.injector });
  }
  private clear(): void {
    this.view.clear();
    this.injector?.destroy();
    this.injector = undefined;
  }
  ngOnDestroy(): void { this.clear(); }
}
